import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Content from "../../components/content/Content";
import ContentBody from "../../components/content/ContentBody";
import ContentHead from "../../components/content/ContentHead";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Component } from "react";
import withRouter from "../../components/withRouter/withRouter";
import InputField from "../../components/inputField/inputField";
import { getHomeData, updateHomeData } from "../../api";
import toast from "react-hot-toast";

class AddUpdateNumber extends Component {
  state = {
    number: "",
    title: "",
    subTitle: "",
    heroData: [],
    _id: "",
    loading: true,
  };

  componentDidMount = () => {
    this.getData();
  };

  getData = async () => {
    getHomeData()
      .then((res) => {
        console.log("home data ::: ", res.data[0].numbers);
        if (this.props.router.params?.id) {
          let val = {};

          if (res.data[0].numbers.length === 1) {
            val = res.data[0].numbers[0];
          } else {
            val = res.data[0].numbers.filter(
              (vv) => vv._id === this.props.router.params.id
            )[0];
          }

          this.setState({
            title: val?.title,
            subTitle: val?.subTitle,
            number: val?.number,
          });
        }

        this.setState({
          _id: res.data[0]?._id,
          heroData: res.data[0]?.numbers,
          loading: false,
        });
      })
      .catch((err) => {});
  };

  validate = () => {
    if (!this.state.title) {
      toast.error("Title is required.");
      return false;
    }
    if (!this.state.subTitle) {
      toast.error("Sub Title is required");
      return false;
    }
    if (!this.state.number) {
      toast.error("Number is required");
      return false;
    }
    return true;
  };

  handleUpdate = () => {
    if (this.validate()) {
      this.setState({ loading: true });

      const data = {
        title: this.state.title,
        subTitle: this.state.subTitle,
        number: this.state.number,
      };

      let hero = [];

      if (this.props.router.params?.id && this.state.heroData.length > 1) {
        hero = this.state.heroData.map((val) => {
          if (val._id === this.props.router.params?.id) {
            return { ...data };
          }
          return val;
        });
      } else if (
        this.props.router.params?.id &&
        this.state.heroData.length <= 1
      ) {
        hero = [{ ...data }];
      } else {
        hero = [...this.state.heroData, { ...data }];
      }

      updateHomeData({ numbers: hero }, this.state._id)
        .then((res) => {
          console.log(res);
          toast.success(
            this.props.router.params?.id
              ? "Updated Successfully."
              : "Added Successfully."
          );
          this.props.router.navigate("/");
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong");
          this.setState({ loading: false });
        });
    }
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title="Add Hero Carousel"
            showBtn1={true}
            btn1Text="Save"
            btn1Name="btn1"
            btn1type="filled"
            showBtn2={true}
            btn2Text="Cancel"
            btn2Name="btn2"
            btn2type="outlined_del"
            onClickHandler={(e) => {
              if (e.target.name === "btn1") {
                this.handleUpdate();
              } else this.props.router.navigate("/");
            }}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <div className="grid_2">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={this.state.title}
                    onChange={(e) => this.setState({ title: e.target.value })}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Sub Title"}
                    value={this.state.subTitle}
                    onChange={(e) =>
                      this.setState({ subTitle: e.target.value })
                    }
                  />
                  <InputField
                    type="number"
                    isLabel={true}
                    lable={"Number"}
                    value={this.state.number}
                    onChange={(e) => this.setState({ number: e.target.value })}
                  />
                </div>
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateNumber);
